// DS: IL3.6
import React from 'react';
export const PremiumTrash = ({ className })=>{
    return /*#__PURE__*/ React.createElement("img", {
        alt: "",
        src: "https://st.deviantart.net/eclipse/global/svg/il05-delete.svg",
        width: "90",
        height: "88",
        className: className
    });
};
